import React from 'react';
import PropTypes from 'prop-types';

const SlowForwardPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M7 4c-.552 0-1 .489-1 1.091V26.91c0 .602.448 1.09 1 1.09h2c.552 0 1-.488 1-1.09V5.091C10 4.489 9.552 4 9 4H7zm6.138.854a.804.804 0 0 0-.138.451v21.39a.804.804 0 0 0 1.256.667l15.492-10.473a1.073 1.073 0 0 0 0-1.778L14.256 4.638a.805.805 0 0 0-1.118.216z"
    />
  );
};

SlowForwardPath.propTypes = {
  fill: PropTypes.string,
};

export default SlowForwardPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/slow-forward.jsx